"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../../utilities/props.js";
import Button from "../Button/index.js";
import IconClose from "../../icons/Close.js";
import s from "./Dismissible.module.css";
const Dismissible = (props) => {
    const { children, align, onClose, hideCloseButton, variant, closeAriaLabel, className, attributes, } = props;
    const rootClassNames = classNames(s.root, className, variant && s[`--variant-${variant}`], align && s[`--align-${align}`], hideCloseButton && s["--hide-close"]);
    const WrapperTag = variant === "media" ? "div" : Button.Aligner;
    return (_jsxs("div", { ...attributes, className: rootClassNames, children: [children, !hideCloseButton && (_jsx(WrapperTag, { className: s.close, children: _jsx(Button, { size: "small", ...(variant === "media" ? { color: "media", variant: "faded" } : { variant: "ghost" }), onClick: () => onClose?.(), attributes: { "aria-label": onClose ? closeAriaLabel : undefined }, icon: IconClose }) }))] }));
};
Dismissible.displayName = "Dismissible";
export default Dismissible;
